import httpClient from "./httpClient";
import { AxiosResponse } from "axios";

export class Ping {
  static ping(): Promise<AxiosResponse> {
    return httpClient.get("/ping");
  }
}
